/**
 * CollectionCard - collection preview card used in grids and carousels.
 * Custom element: <collection-card>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class CollectionCard extends ThemeComponent {}
setFunctionName(CollectionCard, "CollectionCard");
const propertyTypes = {};
CollectionCard.prototype.$name = "CollectionCard";
CollectionCard.prototype.$info = JSON.parse('{"name":"CollectionCard","meta":{"isLegacy":false,"selector":"collection-card"},"props":[],"refs":[]}');
CollectionCard.prototype.$info.component = CollectionCard;
for (const prop of CollectionCard.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Collection/CollectionCard.ts", {
  CollectionCard: CollectionCard
}, void 0);